import React from "react";
import { useLockBodyScroll } from "../../../helpers/useLockBodyScroll";

export const LockScreen = () => {
  useLockBodyScroll();
  return <></>;
};
